export const GET_INFO_CHAT = "GET_INFO_CHAT";
